import Dexie from 'dexie';

export const db = new Dexie('soontech-terrain');

db.version(1).stores({
  zones: 'id, code, name, active, write_date',
  employes: 'id, name, equipe_id, active, write_date',
  equipes: 'id, name, responsable_id, active, write_date',
  categories: 'id, &name, active, write_date',
  unites: 'id, &name, active, write_date',
  variantes: 'id, &name, active, write_date',
  produits: 'id, &reference, categorie_id, unite_mesure_id, active, write_date',
  produits_variantes: 'id, produit_id, variante_tag_id, &code_barres, active, write_date',
  mouvements: '++local_id, &uuid_client, statut, zone_id, employe_id, created_at',
  meta: '&key',
});

db.version(2).stores({
  stock_lignes: 'id, [produit_variante_id+zone_id], zone_id, statut_cloture, active, write_date',
});

db.version(3).stores({
  parametres: 'id, write_date',
});

export async function initializeMeta() {
  await db.meta.bulkPut([
    { key: 'offline_alert_days', value: 3 },
    { key: 'schema_ready', value: true },
  ]);
}

export async function seedDemoData() {
  if (import.meta.env.VITE_ENABLE_DEMO_DATA !== 'true' || await db.zones.count()) return;
  await db.transaction('rw', db.zones, db.equipes, db.employes, db.categories, db.unites, async () => {
    await db.zones.bulkPut([{ id: 1, code: 'A-12', name: 'Zone A-12', active: true }]);
    await db.equipes.bulkPut([{ id: 1, name: 'Équipe Démo', active: true }]);
    await db.employes.bulkPut([{ id: 1, name: 'Employé Démo', equipe_id: [1, 'Équipe Démo'], active: true }]);
    await db.categories.bulkPut([{ id: 1, name: 'Divers', active: true }]);
    await db.unites.bulkPut([{ id: 1, name: 'Pièce', active: true }]);
  });
}
